module.exports = __webpack_public_path__ + "img/PS18.4d76c708.png";